import { ListItem, OrderedList, Text } from '@chakra-ui/react';

export const renderHelpContent = () => {
	return (
		<>
			<Text
				color='easyBLUE.300'
				pt={3}
			>
				Os indicadores de acuracidade são:
			</Text>

			<OrderedList
				pt={3}
				color='easyBLUE.300'
			>
				<ListItem>
					<b>MAPE (Erro Percentual Absoluto Médio):</b>
					<OrderedList style={{ listStyleType: 'lower-alpha' }}>
						<ListItem>
							<b>O que é:</b> mede o erro médio percentual entre o
							valor realizado e o valor previsto. Indica o quanto,
							em média, as previsões se afastam dos resultados
							reais.
						</ListItem>
						<ListItem>
							<b>Como interpretar:</b> o MAPE varia de 0% a 100%.
							Quanto mais próximo de <b>0%</b>, menor o erro e
							maior a acuracidade da previsão.
						</ListItem>
					</OrderedList>
				</ListItem>

				<ListItem>
					<b>WMAPE (Erro Percentual Absoluto Médio Ponderado):</b>
					<OrderedList style={{ listStyleType: 'lower-alpha' }}>
						<ListItem>
							<b>O que é:</b> semelhante ao MAPE, mas pondera os
							erros de cada produto pelo seu volume ou impacto nas
							vendas totais, dando mais peso aos itens mais
							relevantes.
						</ListItem>
						<ListItem>
							<b>Como interpretar:</b> o WMAPE também varia de 0%
							a 100%. Assim como o MAPE, quanto mais próximo de{' '}
							<b>0%</b>, menor o erro e melhor a qualidade da
							previsão.
						</ListItem>
					</OrderedList>
				</ListItem>
			</OrderedList>
		</>
	);
};
